export default {"src":"/_next/static/media/hardware.4d04f923.svg","height":29,"width":23,"blurWidth":0,"blurHeight":0};